import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

var i = 1;
function getId() {
  let kq = i;
  i += 1;
  return kq;
}

const routes = [
  { id: getId(), path: '/', label: 'Home', component: () => import("@/layouts/FrontLayout.vue"), meta: { auth: 0,cls:'' }, children: [
      { id: getId(), path: '', label: 'Home', component: () => import("@/views/Home.vue"), meta: { auth: 0,cls:'' } },
      { id: getId(), path: 'GioiThieu', label: 'GioiThieu', component: () => import("@/views/GioiThieu.vue"), meta: { auth: 0,cls:'' } },
      { id: getId(), path: 'DichVu', label: 'DichVu', component: () => import("@/views/DichVu.vue"), meta: { auth: 0,cls:'' } },
      { id: getId(), path: 'SiteMap', label: 'SiteMap', component: () => import("@/views/SiteMap.vue"), meta: { auth: 0,cls:'' } },
      { id: getId(), path: 'contact', label: 'Contact', component: () => import("@/views/Contact.vue"), meta: { auth: 0,cls:'' } },
      { id: getId(), label: 'Môn Học', path: 'MonHoc', meta: { auth: 0,cls:'' },
        component: ()=>import("@/layouts/MainLayoutSub.vue"), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import("@/views/MonHoc/Toan.vue"), meta: { auth: 0,cls:'' } },
          { id: getId(), label: 'Môn Lý', path: 'Ly', component: () => import("@/views/MonHoc/Ly.vue"), meta: { auth: 0,cls:'' } },
          { id: getId(), label: 'Môn Hóa', path: 'Hoa', component: () => import("@/views/MonHoc/Hoa.vue"), meta: { auth: 0,cls:'' } },
          { id: getId(), label: 'List', path: 'List', component: () => import("@/views/MonHoc/List.vue"), meta: { auth: 0,cls:'' } },
          { id: getId(), label: 'Edit', path: 'Edit/:id', component: () => import("@/views/MonHoc/Edit.vue"), meta: { auth: 0,cls:'' } },
        ]
      },
      { id: getId(), label: 'XaHoi', path: 'XaHoi', meta: { auth: 0,cls:'' },
        component: ()=>import("@/layouts/MainLayoutSub.vue"), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import("@/views/XaHoi/Toan.vue"), meta: { auth: 0,cls:'' } },
        ]
      },
    ]
  },

  { id: getId(), path: '/Admin', label: 'Home', component: () => import("@/layouts/MainLayout.vue"), meta: { auth: 1,cls:'' }, children: [
      { id: getId(), path: '', label: 'Home', component: () => import("@/views/Admin/Home.vue"), meta: { auth: 1,cls:'fa-handshake' } },//fa-cannabis//fa-circle
      //{ id:getId(), path : 'ChangePassword', label:'ChangePassword',meta:{ auth:1,cls:'fa-circle' }, component : ()=>import("@/views/Admin/ChangePassword.vue") },


      /*
      { id: getId(), label: 'Môn Học', path: 'MonHoc', meta: { auth: 9,cls:'fa-circle' },
        component: ()=>import("@/layouts/MainLayoutSub.vue"), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import("@/views/Admin/MonHoc/Toan.vue"), meta: { auth: 9,cls:'fa-user' } },
          { id: getId(), label: 'Môn Lý', path: 'Ly', component: () => import("@/views/Admin/MonHoc/Ly.vue"), meta: { auth: 9,cls:'fa-lock' } },
          { id: getId(), label: 'Môn Hóa', path: 'Hoa', component: () => import("@/views/Admin/MonHoc/Hoa.vue"), meta: { auth: 9,cls:'fa-phone' } },
          { id: getId(), label: 'List', path: 'List', component: () => import("@/views/Admin/MonHoc/List.vue"), meta: { auth: 9,cls:'' } },
          { id: getId(), label: 'Edit', path: 'Edit/:id', component: () => import("@/views/Admin/MonHoc/Edit.vue"), meta: { auth: 9,cls:'' } },
        ]
      },
      */
      { id: getId(), label: 'KhuVucAdmin', path: 'KhuVucAdmin', meta: { auth: 9,cls:'fa-user-cog' },//cls:'fa-user-cog'
        component: ()=>import("@/layouts/MainLayoutSub.vue"), children: [
          { id: getId(), label: 'IconView', path: '', component: () => import("@/views/Admin/KhuVucAdmin/IconView.vue"), meta: { auth: 9,cls:'fa-boxes' } },//cls:'fa-boxes'
          { id: getId(), label: 'ListUser', path: 'ListUser', component: () => import("@/views/Admin/KhuVucAdmin/ListUser.vue"), meta: { auth: 9,cls:'fa-users' } },//cls:'fa-users'
          { id: getId(), label: 'PhanQuyen', path: 'PhanQuyen', component: () => import("@/views/Admin/KhuVucAdmin/PhanQuyen.vue"), meta: { auth: 9,cls:'fa-star' } },//cls:'fa-star'
          { id: getId(), label: 'AllowedTables', path: 'AllowedTables', component: () => import("@/views/Admin/KhuVucAdmin/AllowedTables.vue"), meta: { auth: 9,cls:'fa-filter' } },//cls:'fa-star'
          
        ]
      },
      { id: getId(), label: 'BasicTabulator5', path: 'BasicTabulator5', meta: { auth: 9,cls:'fa-tools' },//cls:'fa-tools'
        component: ()=>import("@/layouts/MainLayoutSub.vue"), children: [
          { id: getId(), label: 'GenBuildTabulator', path: '', component: () => import("@/views/Admin/BasicTabulator5/GenBuildTabulator.vue"), meta: { auth: 9,cls:'fa-user' } },
          { id: getId(), label: 'GenMasterDetail', path: 'GenMasterDetail', component: () => import("@/views/Admin/BasicTabulator5/GenMasterDetail.vue"), meta: { auth: 9,cls:'fa-user' } },
          { id: getId(), label: 'GenTreeView', path: 'GenTreeView', component: () => import("@/views/Admin/BasicTabulator5/GenTreeView.vue"), meta: { auth: 9,cls:'fa-user' } },
          { id: getId(), label: 'DonVi', path: 'DonVi', component: () => import("@/views/Admin/BasicTabulator5/DonVi.vue"), meta: { auth: 9,cls:'fa-user' } },
          { id: getId(), label: 'TestCrud', path: 'TestCrud', component: () => import("@/views/Admin/BasicTabulator5/TestCrud.vue"), meta: { auth: 9,cls:'fa-user' } },

          // { id: getId(), label: 'MyGiaPha', path: 'MyGiaPha', component: () => import("@/views/Admin/BasicTabulator5/MyGiaPha.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'GiaPha', path: 'GiaPha', component: () => import("@/views/Admin/BasicTabulator5/GiaPha.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'TreeCrud', path: 'TreeCrud', component: () => import("@/views/Admin/BasicTabulator5/TreeCrud.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'TreeView', path: 'TreeView', component: () => import("@/views/Admin/BasicTabulator5/TreeView.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'TreeSelect', path: 'TreeSelect', component: () => import("@/views/Admin/BasicTabulator5/TreeSelect.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'TreeSelect2', path: 'TreeSelect2', component: () => import("@/views/Admin/BasicTabulator5/TreeSelect2.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'Lop', path: 'Lop', component: () => import("@/views/Admin/BasicTabulator5/Lop.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'HocSinh', path: 'HocSinh', component: () => import("@/views/Admin/BasicTabulator5/HocSinh.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'Master', path: 'Master', component: () => import("@/views/Admin/BasicTabulator5/Master.vue"), meta: { auth: 9,cls:'fa-user' } },
          // { id: getId(), label: 'MasterView', path: 'MasterView', component: () => import("@/views/Admin/BasicTabulator5/MasterView.vue"), meta: { auth: 9,cls:'fa-user' } },

        ]
      },
      { id: getId(), label: 'NghiepVu', path: 'NghiepVu', meta: { auth: 1,cls:'fa-tasks' },//cls:'fa-tasks'
        component: ()=>import("@/layouts/MainLayoutSub.vue"), children: [
          { id: getId(), label: 'Môn Toán', path: '', component: () => import("@/views/Admin/NghiepVu/Toan.vue"), meta: { auth: 1,cls:'fa-user' } },
        ]
      },
      
      // { id: getId(), label: 'KhongXoa', path: 'KhongXoa', meta: { auth: 1,cls:'fa-circle' },
      //   component: ()=>import("@/layouts/MainLayoutSub.vue"), children: [
      //     { id: getId(), label: 'MyGiaPha', path: '', component: () => import("@/views/Admin/KhongXoa/MyGiaPha.vue"), meta: { auth: 1,cls:'fa-user' } },
      //   ]
      // },

      { id: getId(), label: 'MyGiaPha', path: 'MyGiaPha', meta: { auth: 9,cls:'fa-user-shield' },
        component: ()=>import("@/layouts/MainLayoutSub.vue"), children: [
          { id: getId(), label: 'MyGiaPha', path: '', component: () => import("@/views/Admin/MyGiaPha/MyGiaPha.vue"), meta: { auth: 9,cls:'fa-user' } },
          { id: getId(), label: 'MyGiaPha2', path: 'MyGiaPha2', component: () => import("@/views/Admin/MyGiaPha/MyGiaPha2.vue"), meta: { auth: 9,cls:'fa-user' } },
          
        ]
      },







    ]
  },

  { id:getId(), path : '/ForgotPassword', label:'Quên mật khẩu',meta:{ auth:0,cls:'fa-key' }, component : ()=>import("@/views/ForgotPassword.vue") },
  { id:getId(), path : '/Login', label:'Login',meta:{ auth:0,cls:'fa-circle' }, component : ()=>import("@/views/LoginTest.vue") },
  { id:getId(), path : '/LoginTest', redirect : '/Login', meta:{ auth:0,cls:'fa-circle' } },
  { id:getId(), path :'*', redirect : '/',meta:{ auth:0,cls:'fa-circle' } }
]


import store from '../store'
// import HangModal from '@/views/Admin/BasicTabulator5/HangModal.vue';
// import HoaDon from '@/views/Admin/BasicTabulator5/HoaDon.vue';
store.state.routes = routes;


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


// =====================================================
// JWT helpers
// =====================================================

function getStoredUser() {
  try {
    const value = localStorage.getItem('user')

    if (!value) {
      return null
    }

    return JSON.parse(value)
  }
  catch (e) {
    localStorage.removeItem('user')
    return null
  }
}


function parseJwt(token) {
  try {
    if (!token || token.split('.').length !== 3) {
      return null
    }

    let base64 = token.split('.')[1]
      .replace(/-/g, '+')
      .replace(/_/g, '/')

    while (base64.length % 4) {
      base64 += '='
    }

    const binary = atob(base64)

    const json = decodeURIComponent(
      Array.prototype.map.call(binary, function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join('')
    )

    return JSON.parse(json)
  }
  catch (e) {
    return null
  }
}


function isJwtValid(token) {
  const payload = parseJwt(token)

  if (!payload) {
    return false
  }

  if (payload.exp) {
    const now = Math.floor(Date.now() / 1000)

    if (now >= Number(payload.exp)) {
      return false
    }
  }

  return true
}


function clearAuth() {
  localStorage.removeItem('token')
  localStorage.removeItem('user')
  localStorage.removeItem('level')
}


// =====================================================
// Router guard
//
// meta.auth:
// 0 = public
// 1..9 = AccessLevel tối thiểu
// =====================================================

router.beforeEach((to, from, next) => {

  const auth = to.matched.reduce((max, route) => {
    const routeAuth =
      Number((route.meta && route.meta.auth) || 0)

    return Math.max(max, routeAuth)
  }, 0)


  // Route public.
  if (auth === 0) {
    next()
    return
  }


  const token =
    localStorage.getItem('token') || ''

  const user =
    getStoredUser()


  // Route có auth > 0 bắt buộc có JWT hợp lệ.
  // if (!isJwtValid(token) || !user) {

  //   clearAuth()

  //   next('/')

  //   return
  // }

if (!isJwtValid(token) || !user) {

  clearAuth()

  next({
    path: '/Login',
    query: {
      redirect: to.fullPath
    }
  })

  return
}




  const level =
    Number(user.accessLevel || 0) || 0


  // Tương thích các component cũ đang đọc localStorage.level.
  localStorage.setItem(
    'level',
    String(level)
  )


  if (level >= auth) {

    next()

  }
  else {

    // Đã đăng nhập nhưng không đủ quyền.
    next('/')

  }

})


export default router